// This file was auto-generated by Fern from our API Definition.
/**
 * Did the provider accept this credential?
 *
 * `unknown` is an honest answer, not a failure: it means Agenta found no free,
 * read-only endpoint that proves the credential works. A public catalog endpoint
 * answering successfully never raises the status above `unknown`.
 */
export const CredentialStatus = {
    Valid: "valid",
    Invalid: "invalid",
    Unknown: "unknown",
};
